export default[
    {
        path: '/consulta',
        component: () => import(/* webpackChunkName: "consulta" */ '@/views/Consulta.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_PACIENTES'],
        },
        children:[
            {
                path:'/',
                name:'calendario',
                component: () => import(/* webpackChunkName: "calendario" */ '@/views/consulta/Calendario.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'listado/:medico',
                name:'citasListado',
                component: () => import(/* webpackChunkName: "citasListado" */ '@/views/consulta/ListadoCitas.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'atencion/:id',
                name:'citasAtencion',
                component: () => import(/* webpackChunkName: "citasAtencion" */ '@/views/consulta/DetalleAtencion.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
        ],
    }
]